import * as React from "react";
import { forwardRef } from "react";
const SvgError = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M14.5 5.5l-9 9M5.5 5.5l9 9", stroke: "#d32f2f", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgError);
export { ForwardRef as ReactComponent };
